import { Link } from "wouter";
import { useTranslation } from "@/i18n/useTranslation";
import { Logo } from "./Logo";

export function Footer() {
  const { t, language, setLanguage } = useTranslation();
  return (
    <footer className="border-t border-border bg-white">
      <div className="container mx-auto max-w-[1440px] px-5 md:px-6 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-xs">
              {t("footer.tagline")}
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-semibold text-foreground">{t("footer.product")}</div>
            <ul className="mt-4 space-y-2.5 text-sm text-muted-foreground">
              <li><a href="#features" className="hover:text-foreground transition-colors">{t("nav.features")}</a></li>
              <li><a href="#how" className="hover:text-foreground transition-colors">{t("nav.howto")}</a></li>
              <li><a href="#pricing" className="hover:text-foreground transition-colors">{t("nav.pricing")}</a></li>
              <li><a href="#faq" className="hover:text-foreground transition-colors">{t("nav.faq")}</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-semibold text-foreground">{t("footer.legal")}</div>
            <ul className="mt-4 space-y-2.5 text-sm text-muted-foreground">
              <li><a href="https://worldsoft.info/impressum" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t("footer.imprint")}</a></li>
              <li><a href="https://worldsoft.info/datenschutz-website" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t("footer.privacy")}</a></li>
              <li><Link href="/agb" className="hover:text-foreground transition-colors">{t("footer.terms")}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-semibold text-foreground">{t("footer.languages")}</div>
            <ul className="mt-4 space-y-2.5 text-sm text-muted-foreground">
              {(["de", "en", "it", "fr"] as const).map((l) => (
                <li key={l}>
                  <button
                    onClick={() => setLanguage(l)}
                    className={`hover:text-foreground transition-colors ${language === l ? "text-foreground font-medium" : ""}`}
                  >
                    {l === "de" ? "Deutsch" : l === "en" ? "English" : l === "it" ? "Italiano" : "Français"}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} CookieRobot. {t("footer.rights")}</div>
          <div className="flex items-center gap-4">
            <a href="https://worldsoft.info/impressum" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t("footer.imprint")}</a>
            <a href="https://worldsoft.info/datenschutz-website" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{t("footer.privacy")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
